// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import CalendarPage from './CalendarPage';
import WorkflowPage from './WorkflowPage';
import EditorPage from './EditorPage';
import DataTablesPage from './DataTablesPage';
import FormBuilderPage from './FormBuilderPage';
import WidgetsRoutes from './WidgetsPage';
import CrmPage from './CrmPage';
import FinancialPage from './FinancialPage';
import PeoplePage from './PeoplePage';
import EntityPage from './EntityPage';
import CommunicationPage from './CommunicationPage';
import UtilityPage from './UtilityPage';
import DynamicFormsPage from './DynamicFormsPage';
import DashboardComponentsPage from './DashboardComponentsPage';
import MediaPage from './MediaPage';
import DocumentsPage from './DocumentsPage';
import ReportingPage from './ReportingPage';
import DataExtrasPage from './DataExtrasPage';
import SpeechPage from './SpeechPage';

export default function AdvancedRoutes() {
  return (
    <Routes>
      <Route path="calendar" element={<CalendarPage />} />
      <Route path="workflow" element={<WorkflowPage />} />
      <Route path="editor" element={<EditorPage />} />
      <Route path="data-tables" element={<DataTablesPage />} />
      <Route path="form-builder" element={<FormBuilderPage />} />
      <Route path="widgets/*" element={<WidgetsRoutes />} />
      <Route path="crm" element={<CrmPage />} />
      <Route path="financial" element={<FinancialPage />} />
      <Route path="people" element={<PeoplePage />} />
      <Route path="entity" element={<EntityPage />} />
      <Route path="communication" element={<CommunicationPage />} />
      <Route path="utility" element={<UtilityPage />} />
      <Route path="forms" element={<DynamicFormsPage />} />
      <Route path="dashboard-components" element={<DashboardComponentsPage />} />
      <Route path="media" element={<MediaPage />} />
      <Route path="documents" element={<DocumentsPage />} />
      <Route path="reporting" element={<ReportingPage />} />
      <Route path="data" element={<DataExtrasPage />} />
      <Route path="speech" element={<SpeechPage />} />
    </Routes>
  );
}
